import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import { Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkSquareAlt } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import { Dispatch, AnyAction, bindActionCreators } from 'redux';
import { logout } from '../../store/actions/auth';
import { Link } from 'react-router-dom';
import { get } from 'lodash';
import { IModulesPermissions } from '../../shared/models/rolesPermissionModel';

interface IProps {
    permission: IModulesPermissions;
    show: boolean;
    doLogout:() => void;
    linkClicked:() => void;
}
const Sidebar = (props:IProps) => {
    const { permission } = props;
    const sideLinks = [ {
        path:'/main-dashboard',
        title:'Home',
        access: get(permission.productReturnDashboard,'view',false)
    },
    {
        path:'/admin-dashboard',
        title:'Admin',
        access: get(permission.adminDashboard,'view',false)
    },
    {
        path:'/manage-users',
        title:'Manage Users',
        access: get(permission.manageUsers,'view',false)
    },
    {
        path:'/manage-customers',
        title:'Manage Customers',
        access: get(permission.manageCustomer,'view',false)
    },
    {
        path:'/reports',
        title:'Reports',
        access: get(permission.reports,'view',false)
    },
    {
        path:'/site-configuration',
        title:'Site Configuration',
        access: get(permission.systemConfiguration,'view',false)
    },
    {
        path:'/profile',
        title:'Profile',
        access: get(permission.manageUserProfile,'view',false)
    },
    {
        path:'/change-password',
        title:'Change Password',
        access: true
    }];
    const doLogout = (event: Event) => {
        event.stopPropagation();
        props.doLogout();
    }
    return (
        <div className={"right-sidebar " + (props.show && 'side-show') } >
            {/* <!-- Sidebar scroll--> */}
            <div className="scroll-sidebar">
                {/* <!-- Sidebar navigation--> */}
                <Navbar className="sidebar-nav">
                    <Nav as="ul" className="flex-column">
                        {
                            sideLinks.map((link,index) =>  link.access && 
                                <NavItem key={index} {...link} linkClicked={props.linkClicked} />
                            )
                        }
                    </Nav>
                </Navbar>
                <div className="logout">
                    <a href="#" onClick={(e: any) => doLogout(e)}>Logout <FontAwesomeIcon icon={faExternalLinkSquareAlt}/>
                    </a>
                </div>
                {/* <!-- End Sidebar navigation -->  */}
            </div>
            {/* <!-- End Sidebar scroll--> */}
        </div>
    )
}

const NavItem = (props: any) => (
    <Nav.Item as="li" className="sidebar-item">
        <Link className="sidebar-link waves-effect waves-dark sidebar-link" to={props.path} onClick={props.linkClicked}>{props.title}</Link>
    </Nav.Item>
)

const mapStateToProps = (state: any) => ({
    permission : state.auth.user.permission
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
    doLogout:  bindActionCreators(logout,dispatch)
});

export default connect(mapStateToProps,mapDispatchToProps)(Sidebar)